export const AMENITIES = [
  "Air Conditioning",
  "WiFi",
  "Parking",
  "Smart TV",
  "Washer / Dryer",
  "Indoor Fireplace",
  "Full Kitchen",
  "Barbecue Grill",
  "Toiletries Provided",
  "Pool Table",
] as const;

export const ATTRACTIONS = [
  { name: "Grand Tradition Estate and Gardens", detail: "19 min drive" },
  { name: "Old Town Temecula Community Theater", detail: "28 min drive" },
  { name: "Temecula Creek Inn Golf Course", detail: "33 min drive" },
  { name: "Pechanga Resort & Casino", detail: "33 min drive" },
] as const;

export interface EventType {
  title: string;
  description: string;
}

export const EVENT_TYPES: EventType[] = [
  {
    title: "Weddings & Receptions",
    description:
      "Say 'I do' beneath the cross with the valley as your backdrop. Our panoramic ceremony space, lawns, and decks host the celebration, while the villa keeps your party close all weekend.",
  },
  {
    title: "Corporate Retreats",
    description:
      "Trade the boardroom for 30 private acres. Spacious indoor and outdoor areas make room for breakout sessions, team dinners, and downtime by the pool — all just an hour from San Diego.",
  },
  {
    title: "Family Reunions",
    description:
      "Gather everyone under one roof. With room for up to 16 overnight guests plus space to spread out, Villa Rosa turns a get-together into a multi-day escape.",
  },
  {
    title: "Milestone Celebrations",
    description:
      "Birthdays, anniversaries, showers, and more. Mark the moments that matter with a private, picture-perfect setting and a team ready to handle the details.",
  },
  {
    title: "Photo & Video Shoots",
    description:
      "From editorial to elopements, the estate delivers endless backdrops — golden-hour vistas, elegant interiors, gardens, and architectural detail in every direction.",
  },
  {
    title: "Wellness & Yoga Retreats",
    description:
      "A serene, quiet landscape made for unwinding. Host yoga, meditation, or wellness weekends surrounded by nature and total privacy.",
  },
];

export const FAQS: { q: string; a: string }[] = [
  {
    q: "What amenities are included with the rental?",
    a: "Amenities include basics such as towels, shampoo, conditioner, soap, hair dryers, toothbrushes, and feminine products. Guests can enjoy a Smart TV with Netflix, Hulu, Disney+, and ESPN, a dart board, pool table, games for kids and adults, and strong WiFi. AC, heater, and spacious parking are available. A luxury golf cart and ATV are available for rent during your event as well.",
  },
  {
    q: "How many guests can the property accommodate?",
    a: "The property comfortably accommodates up to 16 overnight guests. We have 4 bedrooms and 3 full bathrooms to ensure everyone has ample space.",
  },
  {
    q: "Are there any restrictions or guidelines we should be aware of?",
    a: "We ask that you adhere to the community quiet hours starting at 10PM. All trash should go in the dumpster at the front gate at the end of your stay. Please be respectful of the property.",
  },
  {
    q: "Is the property accessible for guests with disabilities?",
    a: "Villa Rosa is accessible to ADA guests with easy parking and entry into the house with no stairs. There is an accessible entrance to the ceremony area around the side of the house in lieu of the staircase. Unfortunately, the second floor of the house is only accessible via stairs.",
  },
  {
    q: "What is the booking process and how far in advance should we book?",
    a: "Book through our website directly, or through our Airbnb and VRBO links! We recommend booking as soon as you can, as this property books weddings well in advance.",
  },
  {
    q: "What is your cancellation policy?",
    a: "Our cancellation policy requires notice 30 days prior to your stay. Cancellations made within this period may result in a fee or forfeiture of the deposit.",
  },
  {
    q: "Is parking available for guests?",
    a: "Yes, we have ample parking available for guests on the property.",
  },
  {
    q: "What is the check-in and check-out process?",
    a: "Check-in is at 3PM and check-out is at 11AM. Early check-in and late check-out are available for an additional fee. There will be a code on the door for your convenience and easy access.",
  },
  {
    q: "Is there a BBQ grill or outdoor space for guests to use?",
    a: "Yes, we have an outdoor space with a BBQ grill and a seating area where you can enjoy meals and relax.",
  },
  {
    q: "How can guests reach you if they need assistance during their stay?",
    a: "We are available by phone, text, or the Airbnb messaging system to assist with any questions or concerns you might have during your stay.",
  },
  {
    q: "Is the property suitable for families with children?",
    a: "Yes, the property is family-friendly and has a high chair, kids table, pack-and-play, and kids games available.",
  },
  {
    q: "Are there any additional fees or deposits?",
    a: "Guests wishing to host an event at Villa Rosa may require additional fees. Please contact us with your event details!",
  },
];

/**
 * Placeholder guest testimonials — replace with verified reviews from the
 * owner / Airbnb / Vrbo before launch.
 */
export const TESTIMONIALS = [
  {
    quote:
      "The most beautiful setting for our wedding. The grounds are stunning, the home is spacious, and our guests are still talking about it.",
    author: "Sarah & Daniel",
    context: "Wedding weekend",
  },
  {
    quote:
      "We came for a family getaway and never wanted to leave. Plenty of room for everyone, incredible views, and the game room was a hit.",
    author: "The Martinez Family",
    context: "Family stay",
  },
  {
    quote:
      "Hosted our company retreat here and it exceeded every expectation. Quiet, private, and the perfect mix of work and relaxation.",
    author: "Alyssa R.",
    context: "Corporate retreat",
  },
];
